var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "272",
      "height": "184",
      "viewBox": "0 0 400 312",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_d_546_3906)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M64 32H272.025L320.029 124L272.025 216H64V32ZM275.995 32H279.996L327.999 124L279.996 216H275.995L323.999 124L275.995 32ZM287.996 32H286.996L335 124L286.996 216H287.996L336 124L287.996 32Z",
      "fill": "#1B1C1D"
    }
  })]), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_546_3906",
      "x": "0",
      "y": "0",
      "width": "400",
      "height": "312",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _c('feOffset', {
    attrs: {
      "dy": "32"
    }
  }), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "32"
    }
  }), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.18 0 0 0 0 0.2 0 0 0 0 0.22 0 0 0 0.15 0"
    }
  }), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_546_3906"
    }
  }), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_546_3906",
      "result": "shape"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }